///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Copyright � 2011, GRADE AB.  All rights reserved.
//	@author Xavier Follet - Build on existing LMSAPI.js (SCORM 1.2)
//	@doc INTERNAL
//
//  @module LMSAPI20042004.js |
//		Contains SCORM 2004 LMS API Implementation.
//		This module contains the client side implementation of LMS SCORM 2004 API.
//	
//	@end
//
///////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Global Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////

if (typeof module !== 'undefined') module.exports = LMSAPI2004;

var b_LMS2004Initialized = "false";
var b_LMS2004Terminated = "false";
debug2004 = false;

// XML document where data is stored
var scorm2004XmlDoc;
var xml2004Loaded = false;
var scorm2004NavTreeID;
var scorm2004SessionDocument = null;

// Flag for Ajax call
var b_saveSynchronous2004 = false;

// Error details types: these strings are used to construct Error objects
var gc_strParseError2004 = "XML_Parse_Error";
var gc_strJScriptError2004 = "JScript_Error";
var gc_strMultiStatusError2004 = "Multi-Status_Error";
var gc_strString2004 = "String";
var gc_strNoDetails2004 = "Null";

//ERROR NUMBERS AND STRINGS
var err_0 = "No error";
var err_101 = "General exception";
var err_102 = "General Initialization Failure";
var err_103 = "Already Initialized";
var err_104 = "Content Instance Terminated";
var err_111 = "General Termination Failure";
var err_112 = "Termination Before Initialization";
var err_113 = "Termination After Termination";
var err_122 = "Retrieve Data Before Initialization";
var err_123 = "Retrieve Data After Termination";
var err_132 = "Store Data Before Initialization";

var err_133 = "Store Data After Termination";
var err_142 = "Commit Before Initialization";
var err_143 = "Commit After Termination";

var err_201 = "General Argument Error";
var err_301 = "General Get Failure";
var err_351 = "General Set Failure";
var err_391 = "General Commit Failure";
var err_401 = "Undefined Data Model Element";
var err_402 = "Unimplemented Data Model Element";
var err_403 = "Data Model Element Value Not Initialized";
var err_404 = "Data Model Element Is Read Only";
var err_405 = "Data Model Element Is Write Only";
var err_406 = "Data Model Element Type Mismatch";
var err_407 = "Data Model Element Value Out Of Range";
var err_408 = "Data Model Dependency Not Established";



// Used for CVEO events
var gc_LMSAPI2004_LESSONSTATUS = 200;
var gc_LMSAPI2004_EXITSTATUS = 300;
var gc_CPO_SELECT = 2;

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Utility Functions
//
///////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc INTERNAL
//
//	@jsfunc LRN2004Error | Constructor function for error objects.
//						This object has 4 properties:
//						number: see description about nNumber parameter
//						strDetailsType: see description about strDetailsType parameter
//						oErrorDetails: see description about oErrorDetails parameter
//						description: String describing this error associated with the numeric
//										identifier
//
//	@parm  Integer	| nNumber			| The numeric identifier of this error.  The description
//											string will be loaded from the XML.
//	@parm  String	| strDetailsType	| A string description of the type of information in
//											oErrorDetails. This parameter is
//											required if oErrorDetails is not null, but is ignored
//											if oErrorDetails is null.
//	@parm  Object	| oErrorDetails		| This parameter is optional.  Additional information 
//											about the error that occurred.  The type of this 
//											object is indicated by the strDetailsType parameter.
//
//	@rdesc  Javascript error object or null if arguments are invalid
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function LRN2004Error(nNumber, strDetailsType, oErrorDetails)
{
	// Checking parameter //////////////////////////////////////////////////////////////////////////
	if ("number" != typeof (nNumber))
	{
		return null;
	}

	if ("string" != typeof (strDetailsType))
	{
		strDetailsType = gc_strNoDetails2004;
	}

	if ("undefined" == typeof (oErrorDetails))
	{
		oErrorDetails = null;
	}

	// Object Initialization ///////////////////////////////////////////////////////////////////////
	// conformance to jscript error
	this.number = nNumber;
	this.strDetailsType = strDetailsType;
	this.oErrorDetails = oErrorDetails;
	this.description = Error2004StringFromID(nNumber);

	return this;
}

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc INTERNAL
//
//	@jsfunc Error2004StringFromID	| Searches error XML for the description of an error.
//
//	@parm	Integer	| nNumber	| The numeric identifier of the error for which to search.
//
//	@rdesc  If the ID is found, the error description is returned.
//
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function Error2004StringFromID(nNumber)
{
	try
	{
		return eval("err_" + nNumber);
	} catch (e)
	{
		if ("undefined" == typeof (e.strDetailsType))
		{
			this.m_oLastError = new LRN2004Error(101, gc_strJScriptError2004, e);
		} else
		{
			this.m_oLastError = e;
		}
		return "";
	}
}


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Implementation of the LMSAPI2004 object
//
///////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Constructor of the LMSAPI2004 object
//
///////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  @doc Internal
//
//	@jsfunc		LMSAPI2004				| Constructor for an LMSAPI2004 object.  One LMSAPI2004 object should 
//
//	@rdesc	Returns a newly created LMSAPI2004 object on success.  On failure, returns null.
//
//	@comm 
//			This function cannot throw.
//	@end
//
///////////////////////////////////////////////////////////////////////////////////////////////////
function LMSAPI2004()
{
	try
	{
		// Object Initialization ///////////////////////////////////////////////////////////////////
		// Add member variables
		this.m_bInitialized = false;
		this.m_oLastError = null;
		return this;
	}
	catch (e)
	{
		return null;
	}
}

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Public Methods of LMSAPI2004 object
//
///////////////////////////////////////////////////////////////////////////////////////////////////

//Callback for implementations that want to commit by themselves
LMSAPI2004.prototype.setValueCallBack = null;
LMSAPI2004.prototype.commitCallBack = null;

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  @doc External
//
//	@jsfunc		Initialize | LRN implementation of Initialize, which initializes the LMS API
//								for use by the personalization client.  
//
//	@parm string	| strProperty	|	A string set to "" must be passed for conformance to the current LMS standard.  
//
//	@rdesc	Returns 1 to indicate that the initialization was successful or -1 to indicate
//			a failure.
//
//	@comm 
//			This function cannot throw.
//	@end
//
///////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMS2004Initialize(strProperty)
{
	scorm2004NavTreeID = luvitedu.getNavTreeIdObj().value;

	try
	{
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;

		//Checking if arguements are given to this method, if so we return an error
		if (strProperty != "" && strProperty != null)
		{
			this.m_oLastError = new LRN2004Error(201);
			return "false";
		}

		var contentInstance = getScorm2004ContentInstance();

		if (b_LMS2004Initialized == "true" && contentInstance === scorm2004SessionDocument)
		{
			this.m_oLastError = new LRN2004Error(103);
			return "false";
		}

		//XAV: Removed IE switch

		scorm2004XmlDoc = luvit.getStartXml(Scorm2004StartUrl + "?var=" + getStopRefreshString2004());
		xml2004Loaded = isScorm2004DataLoaded(scorm2004XmlDoc);
		b_LMS2004Initialized = xml2004Loaded ? "true" : "false";
		scorm2004SessionDocument = xml2004Loaded ? contentInstance : null;

		if (xml2004Loaded)
		{
			b_LMS2004Terminated = "false";
		}
		else
		{
			this.m_oLastError = new LRN2004Error(102, gc_strString2004, "Could not load SCORM data from " + Scorm2004StartUrl);
		}
	}
	catch (e)
	{
		if ("undefined" == typeof (e.strDetailsType))
		{
			this.m_oLastError = new LRN2004Error(101, gc_strJScriptError2004, e);
		} else
		{
			this.m_oLastError = e;
		}
		b_LMS2004Initialized = "false";
	}
	return b_LMS2004Initialized;
}

LMSAPI2004.prototype.Initialize = funcLMS2004Initialize;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSGetValue | Implementation of LMSGetValue, which retrieves the value of the 
//							named personalization property. 
//
//	@parm String | strProperty	|	The name of the property to retrieve.
//
//	@rdesc  If the property exists, its value is returned as a string.  Otherwise, "" is returned.
//
//	@comm 
//			This function cannot throw.
//
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMS2004GetValue(strProperty)
{

	try
	{
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;

		//Not initialized -> return Error
		if (b_LMS2004Initialized == "false")
		{
			if (b_LMS2004Terminated == true)
			{
				this.m_oLastError = new LRN2004Error(123);
			}
			else
			{
				this.m_oLastError = new LRN2004Error(122);
			}
			return "";
		}

		var elmToCheck = findScorm2004Node(strProperty);
		if (elmToCheck == null)
		{
			this.m_oLastError = new LRN2004Error(401);
			return "";
		}

		if (elmToCheck.getAttribute("wo") != null && elmToCheck.getAttribute("wo") == "1")
		{
			// Check for writeonly elements and throw readonly
			this.m_oLastError = new LRN2004Error(404);
			return "false";
		}

		var strValue = getScorm2004NodeValue(strProperty);

		//Checking if any value was found
		if (strValue == null)
		{
			strValue = "";
			this.m_oLastError = new LRN2004Error(401);
			return "";
		}


		return strValue;
	} catch (e)
	{
		if ("undefined" == typeof (e.strDetailsType))
		{
			this.m_oLastError = new LRN2004Error(101, gc_strJScriptError2004, e);
		} else
		{
			this.m_oLastError = e;
		}
		//Should return an empty string on error
		return "";
	}
}

LMSAPI2004.prototype.GetValue = funcLMS2004GetValue;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSSetValue | Implementation of LMSSetValue, which sets the value of the named
//							personalization property.  The change is not commited to the store 
//							until LMSCommit or LMSFinish is called.
//
//	@parm String | strProperty	|	The name of the property to modify.
//	@parm String | strValue		|	The value to set.  This must be a number, a boolean, or a
//										string.  We will convert the value to a string before
//										setting it.
//
//	@rdesc  none
//
//	@comm 
//			This function cannot throw.
//
//			
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMS2004SetValue(strProperty, strValue)
{
	var rc;
	try
	{
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;

		if (b_LMS2004Initialized == "false")
		{
			if (b_LMS2004Terminated == "true")
			{
				//after termination
				this.m_oLastError = new LRN2004Error(133);
			}
			else
			{
				//before termination
				this.m_oLastError = new LRN2004Error(132);
			}
			return "";
		}

		// Check for readonly elements and throw readonly
		var elmToCheck = findScorm2004Node(strProperty);

		if (elmToCheck != null && elmToCheck.getAttribute("ro") != null && elmToCheck.getAttribute("ro") == "1")
		{
			this.m_oLastError = new LRN2004Error(403);
			return "false";
		}

		//If a new comment is added, the comments should be concatenated together
		if (strProperty == "cmi.comments")
		{
			strValue = getScorm2004NodeValue(strProperty) + strValue;
		}

		updateScorm2004Data(strProperty, strValue);

		if (debug2004)
			alert("SetValue: " + strProperty + " Val:" + strValue);

		//Call a callback
		if (this.setValueCallBack != null)
			this.setValueCallBack();
		
		return "true";
	} catch (e)
	{
		if ("undefined" == typeof (e.strDetailsType))
		{
			// Return a general error, because we don't know exactly what happened.
			this.m_oLastError = new LRN2004Error(101, gc_strJScriptError2004, e);
		} else
		{
			this.m_oLastError = e;
		}
		//Should return a string with "false" on error
		return "false";
	}
}

LMSAPI2004.prototype.SetValue = funcLMS2004SetValue;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSCommit	| Implementation of LMSCommit, which saves the current set of
//							personalization data to the personalization store.
//
//	@rdesc  none
//
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMS2004Commit(strProperty)
{
	try
	{
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;

		if (strProperty != "")
		{
			this.m_oLastError = new LRN2004Error(201);
			return "false";
		}

		if (b_LMS2004Initialized == "false")
		{
			if (b_LMS2004Terminated == "true")
			{
				//after termination
				this.m_oLastError = new LRN2004Error(143);
			}
			else
			{
				//before termination
				this.m_oLastError = new LRN2004Error(142);
			}
			return "";
		}

		// Saving data
		saveScorm2004Data();

		if (debug2004)
			alert("Commit");

		//Call a callback
		if (this.commitCallBack != null)
			this.commitCallBack();

		return "true";
	} catch (e)
	{
		if ("undefined" == typeof (e.strDetailsType))
		{
			// Return a general error, because we don't know exactly what happened.
			this.m_oLastError = new LRN2004Error(101, gc_strJScriptError2004, e);
		} else
		{
			this.m_oLastError = e;
		}
		return "false";
	}
}

LMSAPI2004.prototype.Commit = funcLMS2004Commit;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSFinish	| Implementation of LMSFinish, which saves the current set of
//							personalization data to the personalization store and terminates the
//							connection to the personalization store.
//
//	@rdesc  none
//		
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMS2004Finish(strProperty)
{
	try
	{
		//No inputs allowed
		if (strProperty != "")
		{
			this.m_oLastError = new LRN2004Error(201);
			return "false";
		}

		//Not initialized -> return Error

		if (b_LMS2004Initialized == "false")
		{
			if (b_LMS2004Terminated == "true")
			{
				//after termination
				this.m_oLastError = new LRN2004Error(113);
			}
			else
			{
				//before termination
				this.m_oLastError = new LRN2004Error(112);
			}
			return "";
		}
		else
		{
			b_LMS2004Initialized = "false";
			b_LMS2004Terminated = "true";
		}

		// Setting cmi.entry to "resume" if cmi.core.exit is "suspend"
		if (getScorm2004NodeValue("cmi.exit") == "suspend")
			updateScorm2004Data("cmi.entry", "resume");
		else
			updateScorm2004Data("cmi.entry", "");

		// Calculating cmi.total_time for this SCO
		updateScorm2004Data("cmi.total_time", AddTime2004(getScorm2004NodeValue("cmi.total_time"), getScorm2004NodeValue("cmi.session_time")));
		updateScorm2004Data("cmi.session_time", "0000:00:00.00");

		//NOT implementing exit = logout -> logout user, Silly function for our LMS				

		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;

		//Saving data
		saveScorm2004Data();

		if (debug2004)
			alert("Finish: true");

		return "true";
	} catch (e)
	{
		if ("undefined" == typeof (e.strDetailsType))
		{
			// Return a general error, because we don't know exactly what happened.
			this.m_oLastError = new LRN2004Error(101, gc_strJScriptError2004, e);
		} else
		{
			this.m_oLastError = e;
		}
		return "false";
	}
}

LMSAPI2004.prototype.Terminate = funcLMS2004Finish;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//
//	@jsfunc LUVITFinishSynchronous	|
//      A custom wrapper of LMSFinish to ensure that the final saving of SCORMData is done through
//		a synchronous ajax call. 
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLUVIT2004FinishSynchronous()
{
	var oldFlag = b_saveSynchronous2004;
	b_saveSynchronous2004 = true;
	try
	{
		this.Terminate("");
	}
	finally
	{
		b_saveSynchronous2004 = oldFlag;
	}
}

LMSAPI2004.prototype.LUVITFinishSynchronous = funcLUVIT2004FinishSynchronous;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSGetLastError	| Implementation of LMSGetLastError, which returns the ID of the
//								last error to occur.  A return value of zero indicates that the
//								last operation was successful.  Multiple consecutive calls to this
//								method will return the same value.
//
//	@rdesc  error number
//		
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMS2004GetLastError()
{
	if (null == this.m_oLastError)
	{
		return 0;
	}
	return this.m_oLastError.number;
}

LMSAPI2004.prototype.GetLastError = funcLMS2004GetLastError;

////////////////////////////////////////////////////////////////////////////////////////////////////
//	@doc External
//
//	@jsfunc LMSGetErrorString	| Implementation of LMSGetErrorString, which returns the 
//									string associated with a specific error ID.
//
//	@parm	Integer	| nErrorNumber	| ID of the error for which to return a description.
//
//	@rdesc  none
//
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMS2004GetErrorString(nErrorNumber)
{
	try
	{
		var strErrorString = Error2004StringFromID(nErrorNumber);
		return strErrorString;
	} catch (e)
	{
		return "";
	}
}

LMSAPI2004.prototype.GetErrorString = funcLMS2004GetErrorString;


////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSGetDiagnostic	| Implementation of LMSGetErrorString, which returns additional
//									information regarding a specific error.  This implementation
//									will only return additional information about the last error to
//									occur.
//
//	@parm	Integer	| nErrorNumber	| ID of the error for which to return a description.  
//										Must be null
//
//	@rdesc  none
//		
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMS2004GetDiagnostic(nErrorNumber)
{
	try
	{
		if (null == this.m_oLastError || 0 == this.m_oLastError.number)
		{
			return "";
		}

		if (nErrorNumber != null && nErrorNumber !== "" && Number(nErrorNumber) !== Number(this.m_oLastError.number))
		{
			return "";
		}

		switch (this.m_oLastError.strDetailsType)
		{
			case gc_strParseError2004:
				return this.m_oLastError.oErrorDetails.reason;
			case gc_strJScriptError2004:
				return this.m_oLastError.oErrorDetails.message || this.m_oLastError.oErrorDetails.description || String(this.m_oLastError.oErrorDetails);
			case gc_strMultiStatusError2004:
				return this.m_oLastError.oErrorDetails.xml;
			case gc_strString2004:
				return this.m_oLastError.oErrorDetails;
			default:
				return "";
		}
	} catch (e)
	{
	}
	return "";
}

LMSAPI2004.prototype.GetDiagnostic = funcLMS2004GetDiagnostic;

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Private Methods of LMSAPI2004 object
//
///////////////////////////////////////////////////////////////////////////////////////////////////

// Return Value: time delta in seconds
function UnFormatTimeDelta2004(strTime)
{
	try
	{
		if ("string" != typeof (strTime))
		{
			return 0;
		}

		var arrTime = strTime.split(":");
		if (3 != arrTime.length)
		{
			return 0;
		}

		var nHours = parseInt(arrTime[0]);
		var nMinutes = parseInt(arrTime[1]);
		var nSeconds = parseInt(arrTime[2]);
		if ((true == isNaN(nHours)) || (true == isNaN(nMinutes)) || (true == isNaN(nSeconds)))
		{
			return 0;
		}

		return (nHours * 60 * 60) + (nMinutes * 60) + nSeconds;
	} catch (e)
	{
		return 0;
	}
}


// Return Value: time delta as string
function FormatTimeDelta2004(nSeconds)
{
	try
	{
		if (("number" != typeof (nSeconds)) || (0 > nSeconds))
		{
			return "0000:00:00.00";
		}

		// 1 hour = 60 minutes * 60 seconds 
		var nHours = Math.floor(nSeconds / (60 * 60));
		nSeconds = nSeconds - (nHours * 60 * 60);

		var nMinutes = Math.floor(nSeconds / 60);
		nSeconds = nSeconds - (nMinutes * 60);

		var strHours = nHours.toString();
		if (nHours < 10)
		{
			strHours = "0" + strHours;
		}

		var strMinutes;
		if (10 > nMinutes)
		{
			// single digit
			strMinutes = "0" + nMinutes.toString();
		} else
		{
			strMinutes = nMinutes.toString();
		}

		var strSeconds;
		if (10 > nSeconds)
		{
			// single digit
			strSeconds = "0" + nSeconds.toString();
		} else
		{
			strSeconds = nSeconds.toString();
		}

		return strHours + ":" + strMinutes + ":" + strSeconds;
	} catch (e)
	{
		return "0000:00:00.00";
	}
}

// Return Value: new time delta as string
function AddTime2004(strTime1, strTime2)
{
	if (strTime1 == null)
		return "0000:00:00.00";

	if (strTime2 == null)
		return strTime1;

	try
	{
		var nTime1 = UnFormatTimeDelta2004(strTime1);
		var nTime2 = UnFormatTimeDelta2004(strTime2);
		var nNewTime = nTime1 + nTime2;
		return this.FormatTimeDelta2004(nNewTime);
	} catch (e)
	{
		return strTime1;
	}
}

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	XML data handling
//
///////////////////////////////////////////////////////////////////////////////////////////////////

//Saving scorm data		
function saveScorm2004Data()
{
    if (getScorm2004ContentInstance() !== scorm2004SessionDocument)
	{
		return;
	}

    if (typeof (luvitedu.getNavTreeIdFromFrameUrlObj) == "function")
	{
        var navTreeIDFromFrameUrl = luvitedu.getNavTreeIdFromFrameUrlObj().value;
        if (navTreeIDFromFrameUrl != null && navTreeIDFromFrameUrl != "" && navTreeIDFromFrameUrl != scorm2004NavTreeID)
		{
			scorm2004NavTreeID = navTreeIDFromFrameUrl;
		}
	}
	ajaxSend(
		"POST",
		Scorm2004SaveUrl + "?scormnavtreeid=" + scorm2004NavTreeID + "&var=" + getStopRefreshString2004(),
		luvit.handleScormSaveCallback2004,
		scorm2004XmlDoc, false,
		!b_saveSynchronous2004, true);
}

function getStopRefreshString2004()
{
	currentDate = new Date();
	return escape(String(currentDate.getHours()) + String(currentDate.getMinutes()) + String(currentDate.getSeconds()) + String(currentDate.getMilliseconds()));
}

//adding new scorm value
function addScorm2004Data(nodeName, nodeValue)
{
	var newNode = scorm2004XmlDoc.createElement("scormnode");
	newNode.setAttribute("id", nodeName);
	newNode.setAttribute("value", nodeValue);
	scorm2004XmlDoc.getElementsByTagName("scormdata")[0].appendChild(newNode);
}

//updating existing scorm value
function updateScorm2004Data(nodeName, nodeValue)
{
	//Try to find and update the node 
	nodeToUpdate = findScorm2004Node(nodeName);
	if (nodeToUpdate != null)
	{
		nodeToUpdate.setAttribute("value", nodeValue);
		return;
	}

	// If not found, it might be a node array that can grow (interactions OR interactions.objectives)
	
	//if we adding a new array item we must update the _counter value and init the new array value
	if (nodeName.indexOf("cmi.interactions.") != -1)
	{
		addArrayData2004(nodeName, nodeValue);
	}
	else
	{
		this.m_oLastError = new LRN2004Error(351);
		return;
	}
}

//Get scorm value
function getScorm2004NodeValue(nodeName)
{

	nodeArr = scorm2004XmlDoc.getElementsByTagName("scormnode");

	for (i = 0; i < nodeArr.length; i++)
	{
		if (nodeArr[i].getAttribute("id") == nodeName)
		{
			return nodeArr[i].getAttribute("value");
		}
	}

	if (nodeName.indexOf("cmi.") != 0)  // Only search custom namespaces
	{
		nodeArr = scorm2004XmlDoc.getElementsByTagName("customnode");
		for (i = 0; i < nodeArr.length; i++)
		{
			if (nodeArr[i].getAttribute("id") == nodeName)
			{
				return nodeArr[i].getAttribute("value");
			}
		}
	}

	return null;
}

function getScorm2004ContentInstance()
{
	try
	{
		return iFrameMainContent.document;
	}
	catch (e)
	{
		return null;
	}
}

function isScorm2004DataLoaded(xmlDoc)
{
	return xmlDoc != null && typeof xmlDoc.getElementsByTagName == "function"
		&& xmlDoc.getElementsByTagName("scormdata").length > 0;
}

function findScorm2004Node(nodeName)
{
	nodeArr = scorm2004XmlDoc.getElementsByTagName("scormnode");
	for (i = 0; i < nodeArr.length; i++)
	{
		if (nodeArr[i].getAttribute("id") == nodeName)
		{
			return nodeArr[i];
		}
	}
	return null;
}

function get2004XML()
{
	try
	{
		var serializer = new XMLSerializer();
		return (serializer.serializeToString(scorm2004XmlDoc));
	}
	catch (ex)
	{
		return (scorm2004XmlDoc.xml);
	}
}



function getIdFromNodeName2004(idIndex, nodeName)
{
	var str1 = nodeName.substr(idIndex, nodeName.length);
	return str1.substr(0, str1.indexOf("."));
}

//Updating array _counter values
function addArrayData2004(nodeName, nodeValue)
{
	if (nodeName.indexOf("cmi.objectives.") == 0)
	{
		var nrObjectives = getScorm2004NodeValue("cmi.objectives._count");
		var currentObjective = getIdFromNodeName2004(15, nodeName);
		if (currentObjective >= nrObjectives)
		{
			updateScorm2004Data("cmi.objectives._count", (Number(currentObjective) + 1));
			addNewObjective2004(currentObjective, nodeName, nodeValue);
		}
		return;
	}
	
	if (nodeName.indexOf("adl.data.") == 0)
	{
		alert("data");
		
		var amountDataStores = parseInt(getScorm2004NodeValue("adl.data._count"));

		alert("amountDataStores" + amountDataStores);


		var requestedDataStore = betterGetIdFromNodeName2004(nodeName, 2);

		alert("requestedDataStore" + requestedDataStore);

		if (requestedDataStore >= amountDataStores) // It is not allowed to add stores. Only the ones created in the manifest are settable
		{
			this.m_oLastError = new LRN2004Error(351);
		}
		else
		{
			updateScorm2004Data(nodeName, nodeValue);
		}
	}
	
	if (nodeName.indexOf("cmi.interactions.") == 0 && nodeName.indexOf(".correct_responses.") == -1 && nodeName.indexOf(".objectives.") <= 5)
	{
		var nrInteractions = getScorm2004NodeValue("cmi.interactions._count");
		var currentInteraction = getIdFromNodeName2004(17, nodeName);
		if (currentInteraction >= nrInteractions)
		{
			updateScorm2004Data("cmi.interactions._count", (Number(currentInteraction) + 1));
			addNewInteraction2004(currentInteraction, nodeName, nodeValue);
		}

		return;
	}

	if (nodeName.indexOf(".correct_responses.") > 0)
	{
		var currentInteraction = getIdFromNodeName2004(17, nodeName);
		var nrInteractionsCorrectResponses = getScorm2004NodeValue("cmi.interactions." + currentInteraction + ".correct_responses._count");
		var currentCorrectResponse = getIdFromNodeName2004(36 + String(currentInteraction).length, nodeName);

		if (currentCorrectResponse >= nrInteractionsCorrectResponses)
		{
			updateScorm2004Data("cmi.interactions." + currentInteraction + ".correct_responses._count", (Number(currentCorrectResponse) + 1));
			addScorm2004Data(nodeName, nodeValue);
		}

		return;
	}

	if (nodeName.indexOf(".objectives.") > 5)
	{
		var currentInteraction = getIdFromNodeName2004(17, nodeName);
		var nrInteractionsObjectives = getScorm2004NodeValue("cmi.interactions." + currentInteraction + ".objectives._count");
		var currentInteractionsObjective = getIdFromNodeName2004(29 + String(currentInteraction).length, nodeName);
		if (currentInteractionsObjective >= nrInteractionsObjectives)
		{
			updateScorm2004Data("cmi.interactions." + currentInteraction + ".objectives._count", (Number(currentInteractionsObjective) + 1));
			addScorm2004Data(nodeName, nodeValue);
		}
	}
}

function betterGetIdFromNodeName2004(strSource, intLevel)
{
	var arrNSs = strSource.split('.');
	if (arrNSs.length > intLevel)
	{
		return parseInt(arrNSs[intLevel]);
	}
	else
	{
		return "";
	}
}

function addNewObjective2004(currentObjective, nodeName, nodeValue)
{
	addScorm2004Data("cmi.objectives." + currentObjective + ".id", "");
	addScorm2004Data("cmi.objectives." + currentObjective + ".score._children", "id,score,success_status,completion_status,progress_measure,description");
	addScorm2004Data("cmi.objectives." + currentObjective + ".id", "");
	addScorm2004Data("cmi.objectives." + currentObjective + ".score._children", "scaled,raw,min,max");
	addScorm2004Data("cmi.objectives." + currentObjective + ".score.scaled", "");
	addScorm2004Data("cmi.objectives." + currentObjective + ".score.raw", "");
	addScorm2004Data("cmi.objectives." + currentObjective + ".score.min", "");
	addScorm2004Data("cmi.objectives." + currentObjective + ".score.max", "");

	addScorm2004Data("cmi.objectives." + currentObjective + ".success_status", "unknown");
	addScorm2004Data("cmi.objectives." + currentObjective + ".completion_status", "unknown");
	addScorm2004Data("cmi.objectives." + currentObjective + ".progress_measure", "");
	addScorm2004Data("cmi.objectives." + currentObjective + ".description", "");


	updateScorm2004Data(nodeName, nodeValue);
}

function addNewDataStore2004(currentObjective, nodeName, nodeValue)
{
	addScorm2004Data("adl.data." + currentObjective + ".id", "");
	addScorm2004Data("cmi.data." + currentObjective + ".store", "");
	updateScorm2004Data(nodeName, nodeValue);
}
function addNewInteraction2004(currentInteraction, nodeName, nodeValue)
{
	addScorm2004Data("cmi.interactions." + currentInteraction + "._children", "id,type,objectives,timestamp,correct_responses,weighting,learner_response,result,latency,description");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".id", "");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".type", "");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".objectives._count", "0");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".timestamp", "");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".correct_responses._count", "0");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".weighting", "");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".learner_response", "");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".result", "");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".latency", "");
	addScorm2004Data("cmi.interactions." + currentInteraction + ".description", "");
	updateScorm2004Data(nodeName, nodeValue);
}
